import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { store } from './store';
import SwUpdatePrompt from './components/SwUpdatePrompt';
import InstallPrompt from './components/InstallPrompt';
import PushSync from './components/PushSync';
import PushBadgeSync from './components/PushBadgeSync';

// vite-plugin-pwa registers the service worker. The hook inside
// <SwUpdatePrompt /> handles the lifecycle (needRefresh + updateServiceWorker).
// In dev (`npm start`) the SW is disabled by config so HMR works as expected.

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <SwUpdatePrompt />
        <InstallPrompt />
        <PushSync />
        <PushBadgeSync />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
